export default __webpack_public_path__ + "static/media/Age_Baby.114f213d.gif";